<template>
    <transition appear name="opacity">
        <div
            @click="open"
            class="card z-4 relative shadow-xl my-4 md:my-5 tablet:my-12 lg:my-16 qhd:my-6 fullhd:my-8 mx-4 cursor-pointer elementHoverShadow"
        >
            <img :src="require(`../../assets/img/references/${image}`)"
                 alt=""
                 class="card_image object-cover w-full h-full z-0"
            >
            <div class="absolute bottom-0 pb-10 pl-3">
                <h1 class="text-white text-3xl md:text-4xl uppercase"> {{ title }} </h1>
                <h3 class="text-blue-400 font-bold uppercase"> {{ subTitle }} </h3>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ReferenceItem',
    props: {
        data: Object,
    },
    computed: {
        title() {
            return this.data.thumbnail.title;
        },
        subTitle() {
            return this.data.thumbnail.subTitle;
        },
        image() {
            return this.data.thumbnail.image;
        },
    },
    methods: {
        open() {
            this.$emit('open', this.data);
        },
    },
};
</script>

<style scoped>
.card {
    height: 18vw;
    width: 18vw;
    background: rgba(0, 0, 0, 0.5);
}

.card_image {
    filter: brightness(50%);
}

@media (max-width: 1440px) {
    .card {
        height: 26vw;
        width: 26vw;
    }
}

@media (max-width: 1280px) {
    .card {
        height: 27.5vw;
        width: 27.5vw;
    }
}

@media (max-width: 1024px) {
    .card {
        height: 30vw;
        width: 30vw;
    }
}

@media (max-width: 920px) {
    .card {
        height: 80vw;
        width: 80vw;
    }
}
</style>
